import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

export async function downloadFile(url, fallbackName) {
  try {
    const r = await api.get(url, { responseType: "blob" });
    const cd = r.headers["content-disposition"] || "";
    const m = cd.match(/filename\*=UTF-8''([^;]+)/) || cd.match(/filename="([^"]+)"/);
    const a = document.createElement("a");
    a.href = URL.createObjectURL(r.data);
    a.download = m ? decodeURIComponent(m[1]) : fallbackName;
    a.click();
    URL.revokeObjectURL(a.href);
  } catch (e) {
    const text = e.response?.data instanceof Blob ? await e.response.data.text() : null;
    toast.error(text ? (JSON.parse(text).detail || "Download non riuscito") : errMsg(e));
  }
}
